import { useState } from "react";
import type { UserProfile } from "@/mocks/configuracoes";

interface NewUserModalProps {
  profiles: UserProfile[];
  onClose: () => void;
}

export default function NewUserModal({ profiles, onClose }: NewUserModalProps) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    profile: "",
    phone: "",
    organization: "",
    sendInvite: true,
  });

  const handleChange = (field: string, value: string | boolean) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl border border-background-200/70 shadow-lg w-full max-w-lg">
        <div className="border-b border-background-200/70 px-6 py-4 flex items-center justify-between rounded-t-xl">
          <h3 className="text-base font-semibold text-foreground-900 font-heading">Novo Usuário</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-background-100 flex items-center justify-center text-foreground-400 hover:text-foreground-600 transition-colors">
            <i className="ri-close-line text-lg" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Nome completo *</label>
            <input type="text" value={form.name} onChange={(e) => handleChange("name", e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" placeholder="Nome do usuário" />
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">E-mail *</label>
            <input type="email" value={form.email} onChange={(e) => handleChange("email", e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" placeholder="usuario@exemplo.com" />
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Perfil *</label>
            <select value={form.profile} onChange={(e) => handleChange("profile", e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none">
              <option value="">Selecione um perfil...</option>
              {profiles.map((p) => <option key={p.id} value={p.name}>{p.name} — {p.description}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Telefone</label>
            <input type="text" value={form.phone} onChange={(e) => handleChange("phone", e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" placeholder="(62) 90000-0000" />
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Organização</label>
            <input type="text" value={form.organization} onChange={(e) => handleChange("organization", e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-900 focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none" placeholder="Organização ou empresa" />
          </div>
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" checked={form.sendInvite} onChange={(e) => handleChange("sendInvite", e.target.checked)} className="w-4 h-4 rounded border-background-300 text-primary-500 focus:ring-primary-400" />
            <span className="text-sm text-foreground-700">Enviar convite por e-mail</span>
          </label>
        </div>
        <div className="border-t border-background-200/70 px-6 py-4 flex justify-end gap-3 rounded-b-xl">
          <button onClick={onClose} className="px-4 py-2 text-sm font-semibold text-foreground-600 bg-background-50 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap">Cancelar</button>
          <button onClick={onClose} className="px-4 py-2 text-sm font-semibold text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap">
            <i className="ri-user-add-line w-4 h-4 inline-flex items-center justify-center mr-1" />Criar usuário
          </button>
        </div>
      </div>
    </div>
  );
}